<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" sm="12">
        <TeamsInformation :team="team" :permissions="permissions" />
      </v-col>
      <v-col md="6" sm="12">
        <TeamsMemberManager :team="team" :members="team.users" :available-roles="assignableRoles" :permissions="permissions" />
      </v-col>
      <v-col v-if="permissions.canAddTeamMembers" md="6" sm="12">
        <TeamsAddMember :team="team" :available-roles="assignableRoles" :permissions="permissions" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import TeamsAddMember from '@/Components/Teams/AddMember'
import TeamsInformation from '@/Components/Teams/Information'
import TeamsMemberManager from '@/Components/Teams/MemberManager'

export default {
   metaInfo: { title: 'Settings' },

   components: {
      TeamsAddMember,
      TeamsInformation,
      TeamsMemberManager
   },

   layout: (h, page) => h(Layout, [page]),

   props: {
      team: {
         type: Object,
         required: true
      },
      availableRoles: {
         type: Array,
         required: true
      },
      permissions: {
         type: Object,
         required: true
      }
   },

   data: () => ({
      //
   }),

   computed: {
      assignableRoles () {
         if (this.team.personal_team) {
            return this.availableRoles.filter(role => role.key.includes('personal'))
         }
         const filtered = this.availableRoles.filter(role => !role.key.includes('personal'))
         if (this.team.id !== 1) {
            return filtered.filter(role => role.key !== 'admin')
         }
         return filtered.filter(role => role.key === 'admin')
      }
   },
}
</script>
